import { render, staticRenderFns } from "./PostScholarship.vue?vue&type=template&id=0d1e8b6d&"
import script from "./PostScholarship.vue?vue&type=script&lang=js&"
export * from "./PostScholarship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports